import React, { FC } from 'react'
import NextHead from 'next/head'
import Script from 'next/script'
import { useRouter } from 'next/router'
import { DefaultSeo } from 'next-seo'
import { buildCmpBrandingCss } from '@lib/utils/cmpBranding'

interface Props {
  client: any
}

const HeadWL: FC<Props> = ({client}) => {
  const { locale = 'de' } = useRouter()

  // The consent banner is one shared consentmanager configuration in Remi's
  // brand (see lib/utils/cmpBranding.ts). Repaint it in the client's colours
  // wherever this white-label head is rendered.
  const cmpBrandingCss = buildCmpBrandingCss(client)

  const googleTagManagerSnippet = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;
    j.addEventListener('load', function() {});
f.parentNode.insertBefore(j,f);
    })
    (window,document,'script','dataLayer','${process.env.NEXT_PUBLIC_GT_ID}');
  `

  const elevarSnippet = `
  try {
          const settings = {};
          const config = (await import("https://shopify-gtm-suite.getelevar.com/configs/b05c98e50a0b3879de67f690478042dd1af5841a/config.js")).default;
          const scriptUrl = settings.proxyPath
          ? settings.proxyPath + config.script_src_custom_pages_proxied
          : config.script_src_custom_pages;

          if (scriptUrl) {
          const { handler } = await import(scriptUrl);
          await handler(config, settings);
        }
        } catch (error) {
          console.error("Elevar Error:", error);
        }
  `


  const seoConfig = {
    "title": client?.pageTitle,
    "defaultTitle": client?.pageTitle,
    "titleTemplate": client?.pageTitle,
    "description": client?.pageTitle,
    "openGraph": {
      "title": client?.pageTitle,
      "description": client?.pageTitle,
      "type": "website",
      "locale": "de_DE",
      "url": client?.domain,
    }
  }

  // @ts-ignore
  return (
    <>
      <DefaultSeo{...seoConfig} />
      <NextHead>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#f6f6f8"/>
        <meta name="color-scheme" content="light only"/>
        <link rel="manifest" href="/site.webmanifest" key="site-manifest" />
        <title>{client?.pageTitle}</title>
        <link rel="icon" type="image/png" href={client?.faviconUrl}/>
        {cmpBrandingCss !== '' && (
          <style
            key="cmp-branding"
            dangerouslySetInnerHTML={{ __html: cmpBrandingCss }}
          />
        )}
      </NextHead>

      <Script id="gtag-base" type="text/plain" className="cmplazyload" data-cmp-vendor="s26" strategy="lazyOnload">
        {googleTagManagerSnippet}
      </Script>
      <Script id="elevar-snippet" type="module" strategy="lazyOnload">
        {elevarSnippet}
      </Script>

      {/* <!-- Google Tag Manager (noscript) --> */}
      <noscript id="gtag-noscript">
        <iframe src={`https://www.googletagmanager.com/ns.html?id=${process.env.NEXT_PUBLIC_GT_ID}`}
                height="0" width="0" style={{ display: 'none', visibility: 'hidden' }}></iframe>
      </noscript>
      {/* <!-- End Google Tag Manager (noscript) --> */}
    </>
  )
}

export default HeadWL
